import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Spin } from 'antd'
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc'
import { arrayMoveImmutable } from 'array-move'

import Layout from '../components/layout/Layout'
import axiosInstance from '../utils/axiosInstance'

const DragHandle = sortableHandle(() => <span style={{ cursor: 'grab', marginRight: 8 }}>☰</span>)

const SortableItem = sortableElement(({ item, navigate }) => (
  <li
    style={{
      listStyle: 'none',
      padding: '8px 12px',
      margin: '4px 0',
      border: '1px solid #ddd',
      borderRadius: 4,
      background: '#fff',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    }}
    onClick={() => {
      console.log(item)
      navigate(`/createSection?getStartedItemId=${item._id}`)
    }}
  >
    <DragHandle />
    {item.title}
  </li>
))

function GetStarted() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [getStartedData, setGetStartedData] = useState([])

  const SortableList = sortableContainer(({ items }) => {
    return (
      <ul style={{ padding: 0, margin: 0 }}>
        {items.map((item, index) => (
          <SortableItem key={item._id} index={index} item={item} navigate={navigate} />
        ))}
      </ul>
    )
  })

  const handleCreateGetStarted = () => {
    navigate(`/createSection`)
  }

  const getData = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(`/api/v1/appInputs/getGetStartedData`)
      setGetStartedData(response.data.getStartedData)
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setGetStartedData((items) => {
      const updatedOrderArray = arrayMoveImmutable(items, oldIndex, newIndex)
      updateOrder(updatedOrderArray) // to update at backend
      return updatedOrderArray
    })
  }

  const updateOrder = async (array) => {
    try {
      setLoading(true)
      const response = await axiosInstance.put(`/api/v1/appInputs/setOrderedGetStartedData`, {
        ids: array.map((elem) => ({ _id: elem._id })),
      })
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  return (
    <Layout>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleCreateGetStarted}>
          Create Section
        </Button>
      </div>
      <p>You can drag items to reorder the titles. Changes will be saved automatically.</p>
      {loading ? <Spin /> : <SortableList items={getStartedData} onSortEnd={onSortEnd} useDragHandle />}
    </Layout>
  )
}

export default GetStarted
